import React from 'react';
import {
  XMarkIcon,
  DocumentTextIcon,
  ArrowPathIcon,
} from '../../icons';
import ToastViewer from './ToastViewer';

const SummaryVersionModal = ({
  selectedSummaryVersion,
  setSelectedSummaryVersion,
  savingSummaryVersion,
  createNewSummaryVersion,
  userName,
  transcription,
  processVersionContent,
}) => {
  if (!selectedSummaryVersion) return null;

  return (
    <div className="md-modal-overlay p-2 sm:p-3">
      <div className="md-modal md-modal-lg flex flex-col" role="dialog" aria-modal="true">
        <div className="md-modal-header-primary shrink-0">
          <div className="flex items-start sm:items-center gap-3 min-w-0">
            <div className="md-icon-well bg-white text-matdash-primary shrink-0">
              <DocumentTextIcon className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <h2 className="text-lg sm:text-xl font-semibold text-white mb-0">
                Summary Version {selectedSummaryVersion.version_number}
              </h2>
              <p className="text-white/80 text-xs sm:text-sm mt-0.5 mb-0">
                Created: {new Date(selectedSummaryVersion.created_at).toLocaleString()} •
                By: {selectedSummaryVersion.created_by_name || 'Unknown User'} •
                {selectedSummaryVersion.word_count} words •
                {selectedSummaryVersion.character_count} characters
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <span className="px-3 py-1 bg-white/20 text-white text-xs font-medium rounded-full">
              Available
            </span>
            <button
              onClick={() => setSelectedSummaryVersion(null)}
              className="text-white/80 hover:text-white p-1"
              type="button"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="md-modal-body overflow-y-auto flex-1 max-h-[60vh]">
          <div className="md-viewer-well">
            <ToastViewer
              content={processVersionContent(selectedSummaryVersion.content, selectedSummaryVersion)}
              className="toast-viewer-content"
            />
          </div>
        </div>

        <div className="md-modal-footer shrink-0 justify-end">
          <button
            onClick={() => setSelectedSummaryVersion(null)}
            type="button"
            className="md-btn md-btn-outline"
          >
            Close
          </button>
          {!selectedSummaryVersion.is_current && (
            <button
              onClick={() => {
                if (window.confirm(`Restore to summary version ${selectedSummaryVersion.version_number}? This will create a new version.`)) {
                  createNewSummaryVersion(selectedSummaryVersion.content, 'restore', `Restored to version ${selectedSummaryVersion.version_number} by ${userName}`);
                  setSelectedSummaryVersion(null);
                }
              }}
              disabled={savingSummaryVersion}
              type="button"
              className="md-btn bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-50 inline-flex items-center gap-2"
            >
              <ArrowPathIcon className="h-4 w-4" />
              {savingSummaryVersion ? 'Restoring...' : 'Restore This Version'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryVersionModal;
